import { ticket } from '@lib/api/v2';

/**
 * 해당 좌석에 입장
 * @param {*} data : { merchantId: string; userId: string; ticketId: string; seatId: string; }
 * @returns
 */
export const forceEnter = (data: any) => ticket.patch(`/forceEnter`, data);

/**
 * 회원 정보 조회
 * @param {*} merchantId
 * @param {*} userId
 */
export const userTicketList = (merchantId: number, userId: number, type: any) =>
  ticket.get(`/userTicketList/${merchantId}/${userId}/${type}`);

/**
 * 단일 이용권 상세 정보 조회
 * @param {*} ticketId
 */
export const getTicketById = (ticketId: number) => ticket.get(`/${ticketId}`);

/**
 * 전체 티켓 리스트 조회 (V2 - 서버사이드 필터링)
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @param {number} page - 페이지 번호 (default: 1)
 * @param {number} limit - 페이지당 아이템 수 (default: 20)
 * @param {object} filters - 필터 옵션
 */
export const getAllTicketList = (
  startDate: string,
  endDate: string,
  page: number = 1,
  limit: number = 20,
  filters: {
    isOvertime?: boolean;
    activeOnly?: boolean;
    ticketTypes?: string[];
    ticketLevels?: string[];
    usageStatus?: string[];
    blockStatus?: string[];
    phoneNumber?: string;
    ticketId?: string;
  } = {},
) => {
  const params: any = {
    startDate,
    endDate,
    page,
    limit,
  };

  if (filters.isOvertime) params.isOvertime = true;
  if (filters.activeOnly) params.activeOnly = true;
  // 빈 배열도 전송 (체크박스 전체 해제 시 결과 없음 처리)
  if (filters.ticketTypes !== undefined)
    params.ticketTypes = filters.ticketTypes.length > 0 ? filters.ticketTypes.join(',') : '';
  if (filters.ticketLevels !== undefined)
    params.ticketLevels = filters.ticketLevels.length > 0 ? filters.ticketLevels.join(',') : '';
  if (filters.usageStatus !== undefined)
    params.usageStatus = filters.usageStatus.length > 0 ? filters.usageStatus.join(',') : '';
  if (filters.blockStatus !== undefined)
    params.blockStatus = filters.blockStatus.length > 0 ? filters.blockStatus.join(',') : '';
  if (filters.phoneNumber) params.phoneNumber = filters.phoneNumber;
  if (filters.ticketId) params.ticketId = filters.ticketId;

  return ticket.get(`/list/all`, { params });
};

/**
 * 이용권 차단/해제 (V2)
 * @param {number} ticketId - 이용권 ID
 * @param {number} block - 차단 여부 (0: 해제, 1: 차단)
 */
export const blockTicket = (data: { ticketId: number; block: number }) =>
  ticket.patch(`/block`, data);

/**
 * 강제 퇴장 (V2) - 차단 없이 퇴장만
 * @param {number} ticketId - 이용권 ID
 */
export const forceExitTicket = (data: { ticketId: number }) =>
  ticket.patch(`/force-exit`, data);

/**
 * 외출 처리 (V2, LETMEUP-522) - 좌석 점유는 유지, status만 rest로 전환
 * @param {number} ticketId - 이용권 ID
 */
export const restTicket = (data: { ticketId: number }) =>
  ticket.patch(`/rest`, data);

/**
 * 외출 복귀 (V2, LETMEUP-522)
 * @param {number} ticketId - 이용권 ID
 */
export const reenterTicket = (data: { ticketId: number }) =>
  ticket.patch(`/reenter`, data);

export const getMerchantTicketList = () => ticket.get('/merchant/list');

export const createMerchantTicket = (data: any) => ticket.post('/merchant', data);

export const updateMerchantTicket = (data: any[]) => ticket.patch('/merchant', data);

export const deleteMerchantTicket = (merchantTicketId: number) =>
  ticket.delete(`/merchant/${merchantTicketId}`);

/**
 * 세미나실 예약 알림톡(TI_8776) 수동 재발송
 * @param data : { ticketId: number }
 */
export const resendSeminarNotification = (data: { ticketId: number }) =>
  ticket.post('/resend-seminar-notification', data);
